import angular from 'angular';

import routing from './account.routes';
import AccountCtrl from './account.controller';

import CallingCodes from '../../constants/calling-codes';

import HeaderNav from '../../directives/header-nav';
import LwPageFooter from '../../directives/lw-page-footer';

import User from '../../models/user';
import Customer from '../../models/customer';
import Member from '../../models/member';
import AuthCodeModal from '../../modals/auth-code';
import PaymentModalConf from '../../modals/payment';
import SubscriptionModalConf from '../../modals/subscription';
import RemovePhoneModalConf from '../../modals/remove-phone';
import ReferralModalConf from '../../modals/referral';
import AccountSetupModalConf from '../../modals/account-setup';
import RemoveUserModalConf from '../../modals/remove-user';

import TelFilter from '../../filters/tel';
import TitlecaseFilter from '../../filters/titlecase';

import PlansServ from '../../services/plans';
import BoxServ from '../../services/box';
import CouponServ from '../../services/coupon';
import DropboxServ from '../../services/dropbox';
import ClioServ from '../../services/clio';
import AnalyticsServ from '../../services/analytics';

export default angular.module('pages.account', [HeaderNav, LwPageFooter, CallingCodes,
		User, Customer, Member, AuthCodeModal, TelFilter, PlansServ, BoxServ, CouponServ,
		DropboxServ, PaymentModalConf, SubscriptionModalConf, RemovePhoneModalConf,
		RemoveUserModalConf, ReferralModalConf,TitlecaseFilter, ClioServ
	])
	.controller('AccountCtrl', AccountCtrl)
	.config(routing)
	.name;



// WEBPACK FOOTER //
// ./project/pages/account/index.js